import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';

const PhoneInput = forwardRef((props, ref) => {
  if (ref) {
    return (
      <MaskedInput
        {...props}
        mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
        placeholderChar={'\u2000'}
        showMask
        guide={false}
      />
    );
  }
  return null;
});

PhoneInput.propTypes = {
  ref: PropTypes.func.isRequired,
};

export default PhoneInput;
